module.exports = __webpack_public_path__ + "images/icons_v2/volume-mid-filled-7dcaf527.svg";